var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 38,
    cy: 38,
    r: 38,
    transform: "rotate(-180 38 38)",
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.6054 24L38.6066 24C39.3054 24 39.9662 24.3119 40.4033 24.8483L54.4917 42.1059C55.2897 43.0824 55.1306 44.5102 54.1377 45.295C53.1448 46.0798 51.6929 45.9233 50.8949 44.9468L38.602 29.8882L26.1026 45.1544C25.3035 46.1297 23.8516 46.2839 22.8599 45.4991C21.8681 44.7132 21.7113 43.2854 22.5093 42.31L36.8076 24.846C37.2458 24.3119 37.9055 24 38.6043 24L38.6054 24Z",
    fill: "#515151"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUp);
export default __webpack_public_path__ + "static/media/ArrowUp.9c4fc75db57c792d3d47b38e2a5fbb12.svg";
export { ForwardRef as ReactComponent };